export default "__VITE_ASSET__vvLq7X3J__"